import { render, staticRenderFns } from "./GDialog.vue?vue&type=template&id=d5169640&scoped=true&"
import script from "./GDialog.vue?vue&type=script&lang=js&"
export * from "./GDialog.vue?vue&type=script&lang=js&"
import style0 from "./GDialog.vue?vue&type=style&index=0&id=d5169640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5169640",
  null
  
)

export default component.exports